import get from "lodash/get";
import reverse from "lodash/reverse";

export const getLocationInputValue = (heirarcy) => {
  const arr = [`${get(heirarcy, "zoneNodeType")}-${get(heirarcy, "nodeId")}`];
  heirarcy = get(heirarcy, "parent");
  while (heirarcy) {
    arr.push(`${get(heirarcy, "type")}-${get(heirarcy, "id")}`);
    heirarcy = get(heirarcy, "parent");
  }
  reverse(arr);
  return arr;
};
